// extracted by mini-css-extract-plugin
export var button = "_ng-0";